import {
  CALL_AVERAGE_EMP_SUCCESS,
  CALL_AVERAGE_EMP_FAIL,
  SET_MESSAGE,
  CALL_AVERAGE_EMP_PENDING,
} from "../types";
import UserService from "../../services/user.service";
import { toast } from "react-toastify";

export const getCallAveragEmployee = (body) => async (dispatch) => {
  dispatch({
    type: CALL_AVERAGE_EMP_PENDING,
    payload: { callAvgEmp: "isLoading" },
  });
  return await UserService.getCallAvgEmp(body)
    .then(
      (data) => {
        console.log(data);
        data.data.status
          ? dispatch({
              type: CALL_AVERAGE_EMP_SUCCESS,
              payload: { callAvgEmp: data.data.result[0] },
            })
          : dispatch({
              type: CALL_AVERAGE_EMP_FAIL,
            });
        return Promise.resolve();
      },
      (error) => {
        console.log("error......", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: CALL_AVERAGE_EMP_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    )
    .catch((error) => {
      console.log(error);
    });
};
